var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 4.58333C9.33366 5.20217 9.08783 5.79566 8.65024 6.23325C8.21266 6.67083 7.61916 6.91667 7.00033 6.91667C6.38149 6.91667 5.78799 6.67083 5.35041 6.23325C4.91282 5.79566 4.66699 5.20217 4.66699 4.58333C4.66699 3.96449 4.91282 3.371 5.35041 2.93342C5.78799 2.49583 6.38149 2.25 7.00033 2.25C7.61916 2.25 8.21266 2.49583 8.65024 2.93342C9.08783 3.371 9.33366 3.96449 9.33366 4.58333Z",
    stroke: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 8.66406H5.83366C5.06011 8.66406 4.31825 8.97135 3.77126 9.51833C3.22428 10.0653 2.91699 10.8072 2.91699 11.5807C2.91699 11.8901 3.03991 12.1869 3.2587 12.4057C3.47749 12.6245 3.77424 12.7474 4.08366 12.7474H9.91699C10.2264 12.7474 10.5232 12.6245 10.742 12.4057C10.9607 12.1869 11.0837 11.8901 11.0837 11.5807C11.0837 10.8072 10.7764 10.0653 10.2294 9.51833C9.68241 8.97135 8.94054 8.66406 8.16699 8.66406Z",
    stroke: "#444444",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackUserIcon);
export default __webpack_public_path__ + "static/media/Black_User_Icon.7ef10813726bdc41d187455844425132.svg";
export { ForwardRef as ReactComponent };